import React from 'react';
import './ImagePlaceholder.css';

/**
 * ImagePlaceholder — a styled placeholder block that displays a description
 * of the photograph or video that should fill this slot.
 *
 * Designed to feel intentional now (not broken), and easy to swap with
 * a real <img> or <video> later.
 *
 * Props:
 *   - aspect: '16/9' | '4/5' | '1/1' | '3/4' | '21/9' | string (CSS aspect-ratio)
 *   - tag: small label shown in the top-left corner (e.g. "HERO PHOTO", "VIDEO LOOP")
 *   - description: longer text describing the shot
 *   - dark: render with a dark/navy background instead of cream
 *   - className: additional class(es) for outer wrapper
 */
const ImagePlaceholder = ({
  aspect = '16/9',
  tag = 'PHOTO',
  description = '',
  dark = false,
  className = '',
}) => {
  return (
    <div
      className={`image-placeholder ${dark ? 'image-placeholder--dark' : ''} ${className}`}
      style={{ aspectRatio: aspect }}
      role="img"
      aria-label={description}
    >
      <div className="image-placeholder__inner">
        <span className="image-placeholder__tag">{tag}</span>
        <span className="image-placeholder__icon" aria-hidden="true">⊹</span>
        <p className="image-placeholder__description">{description}</p>
      </div>
    </div>
  );
};

export default ImagePlaceholder;
